import React, { useState } from 'react';
import { LayoutDashboard, Wine, Tag, Users, Activity, Settings, User, ChevronLeft, ChevronRight, Bell, IceCream } from 'lucide-react';
export function Sidebar() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const navigationItems = [{
    icon: <LayoutDashboard className="w-5 h-5" data-id="element-67" />,
    label: 'Dashboard',
    active: true
  }, {
    icon: <Wine className="w-5 h-5" data-id="element-68" />,
    label: 'Products'
  }, {
    icon: <Tag className="w-5 h-5" data-id="element-69" />,
    label: 'Labels'
  }, {
    icon: <Users className="w-5 h-5" data-id="element-70" />,
    label: 'Suppliers'
  }, {
    icon: <Bell className="w-5 h-5" data-id="element-71" />,
    label: 'Notifications'
  }, {
    icon: <Settings className="w-5 h-5" data-id="element-72" />,
    label: 'Settings'
  }];
  return <aside className={`fixed inset-y-0 left-0 bg-white border-r transition-all duration-300 ${isCollapsed ? 'w-20' : 'w-64'}`} data-id="element-73">
      <div className="flex items-center h-16 px-6 border-b" data-id="element-74">
        <div className="flex items-center space-x-3" data-id="element-75">
          <div className="flex items-center justify-center w-8 h-8 bg-purple-50 rounded-lg" data-id="element-76">
            <IceCream className="w-5 h-5 text-purple-600" data-id="element-77" />
          </div>
          {!isCollapsed && <span className="text-lg font-semibold text-gray-900" data-id="element-78">Scoop</span>}
        </div>
      </div>
      <nav className="p-4 space-y-1" data-id="element-79">
        {navigationItems.map((item, index) => <a key={index} href="#" className={`flex items-center px-3 py-2 text-sm font-medium rounded-lg ${item.active ? 'bg-purple-50 text-purple-600' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-80">
            {item.icon}
            {!isCollapsed && <span className="ml-3" data-id="element-81">{item.label}</span>}
          </a>)}
      </nav>
      <div className="absolute bottom-4 w-full px-4" data-id="element-82">
        <div className={`flex items-center px-3 py-2 space-x-3 ${isCollapsed ? 'justify-center' : ''}`} data-id="element-83">
          <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center" data-id="element-84">
            <User className="w-4 h-4 text-gray-600" data-id="element-85" />
          </div>
          {!isCollapsed && <div className="flex-1" data-id="element-86">
              <p className="text-sm font-medium" data-id="element-87">Robin Woods</p>
              <p className="text-xs text-gray-500" data-id="element-88">Administrator</p>
            </div>}
        </div>
      </div>
      <button onClick={() => setIsCollapsed(!isCollapsed)} className="absolute -right-3 top-20 p-1.5 bg-white border rounded-full hover:bg-gray-50" data-id="element-89">
        {isCollapsed ? <ChevronRight className="w-4 h-4 text-gray-600" data-id="element-90" /> : <ChevronLeft className="w-4 h-4 text-gray-600" data-id="element-91" />}
      </button>
    </aside>;
}